/*eslint-disable*/
import { GET_ALL_ROLES, PAGINATE_ROLES, GET_ROLE } from "../actionTypes";

const initialState: RolesState = {
  roles: {
    content: [],
    pageable: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
      paged: false,
      unpaged: false,
    },
    totalPages: 0,
    totalElements: 0,
    last: false,
    number: 0,
    size: 0,
    numberOfElements: 0,
    first: false,
    empty: false,
  },
};

export const RolesReducer = (
  state: RolesState = initialState,
  action: RolesActions
) => {
  switch (action.type) {
    case GET_ALL_ROLES:
      return {
        ...state,
        roles: action.payload,
      };
    case PAGINATE_ROLES:
      return {
        ...state,
        roles: action.payload,
      };
    case GET_ROLE:
      return {
        ...state,
        role: action.payload,
      };
    default:
      return state;
  }
};
